/* eslint-disable id-length */
import getRecaptchaKey from './getRecaptchaKey';
import loadRecaptchaScript from './loadRecaptchaScript';
import initRecaptchaUIBlocks from './initRecaptchaUIBlocks';
import initAndRenderRecaptchaWidget from './initAndRenderRecaptchaWidget';
import executeInvisible from './executeRecaptchaInvisible';
import renderRecaptchaWidget from './renderRecaptchaWidget';
import renderRecaptchaWidgetOnVisible from './renderRecaptchaWidgetOnVisible';

/**
 * @description
 * Методы для работы с Google ReCaptcha
 */
export default {
  getRecaptchaKey,
  loadRecaptchaScript,
  initRecaptchaUIBlocks,
  render: initAndRenderRecaptchaWidget,
  executeInvisible,
  renderRecaptchaWidget,
  renderRecaptchaWidgetOnVisible,
};
